tinymce.addI18n('en_GB', {
  Cut: 'Cut',
  'Heading 5': 'Heading 5',
  'Header 2': 'Header 2',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.",
  'Heading 4': 'Heading 4',
  Div: 'Div',
  'Heading 2': 'Heading 2',
  Paste: 'Paste',
  Close: 'Close',
  'Font Family': 'Font Family',
  Pre: 'Pre',
  'Align right': 'Align right',
  'New document': 'New document',
  Blockquote: 'Blockquote',
  'Numbered list': 'Numbered list',
  'Heading 1': 'Heading 1',
  Headings: 'Headings',
  'Increase indent': 'Increase indent',
  Formats: 'Formats',
  Headers: 'Headers',
  'Select all': 'Select all',
  'Header 3': 'Header 3',
  Blocks: 'Blocks',
  Undo: 'Undo',
  Strikethrough: 'Strike-through',
  'Bullet list': 'Bullet list',
  'Header 1': 'Header 1',
  Superscript: 'Superscript',
  'Clear formatting': 'Clear formatting',
  'Font Sizes': 'Font Sizes',
  Subscript: 'Subscript',
  'Header 6': 'Header 6',
  Redo: 'Redo',
  Paragraph: 'Paragraph',
  Ok: 'Ok',
  Bold: 'Bold',
  Code: 'Code',
  Italic: 'Italic',
  'Align center': 'Align centre',
  'Header 5': 'Header 5',
  'Heading 6': 'Heading 6',
  'Heading 3': 'Heading 3',
  'Decrease indent': 'Decrease indent',
  'Header 4': 'Header 4',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.': 'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.',
  Underline: 'Underline',
  Cancel: 'Cancel',
  Justify: 'Justify',
  Inline: 'Inline',
  Copy: 'Copy',
  'Align left': 'Align left',
  'Visual aids': 'Visual aids',
  'Lower Greek': 'Lower Greek',
  Square: 'Square',
  Default: 'Default',
  'Lower Alpha': 'Lower Alpha',
  Circle: 'Circle',
  Disc: 'Disc',
  'Upper Alpha': 'Upper Alpha',
  'Upper Roman': 'Upper Roman',
  'Lower Roman': 'Lower Roman',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.': 'ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.',
  Name: 'Name',
  Anchor: 'Anchor',
  Id: 'ID',
  'You have unsaved changes are you sure you want to navigate away?': 'You have unsaved changes are you sure you want to navigate away?',
  'Restore last draft': 'Restore last draft',
  'Special character': 'Special character',
  'Source code': 'Source code',
  Language: 'Language',
  'Insert/Edit code sample': 'Insert/Edit code sample',
  B: 'B',
  R: 'R',
  G: 'G',
  Color: 'Colour',
  'Right to left': 'Right to left',
  'Left to right': 'Left to right',
  Emoticons: 'Emoticons',
  Robots: 'Robots',
  'Document properties': 'Document properties',
  Title: 'Title',
  Keywords: 'Keywords',
  Encoding: 'Encoding',
  Description: 'Description',
  Author: 'Author',
  Fullscreen: 'Full-screen',
  'Horizontal line': 'Horizontal line',
  'Horizontal space': 'Horizontal space',
  'Insert/edit image': 'Insert/edit image',
  General: 'General',
  Advanced: 'Advanced',
  Source: 'Source',
  Border: 'Border',
  'Constrain proportions': 'Constrain proportions',
  'Vertical space': 'Vertical space',
  'Image description': 'Image description',
  Style: 'Style',
  Dimensions: 'Dimensions',
  'Insert image': 'Insert image',
  Image: 'Image',
  'Zoom in': 'Zoom in',
  Contrast: 'Contrast',
  Back: 'Back',
  Gamma: 'Gamma',
  'Flip horizontally': 'Flip horizontally',
  Resize: 'Resize',
  Sharpen: 'Sharpen',
  'Zoom out': 'Zoom out',
  'Image options': 'Image options',
  Apply: 'Apply',
  Brightness: 'Brightness',
  'Rotate clockwise': 'Rotate clockwise',
  'Rotate counterclockwise': 'Rotate counterclockwise',
  'Edit image': 'Edit image',
  'Color levels': 'Colour levels',
  Crop: 'Crop',
  Orientation: 'Orientation',
  'Flip vertically': 'Flip vertically',
  Invert: 'Invert',
  'Date/time': 'Date/time',
  'Insert date/time': 'Insert date/time',
  'Remove link': 'Remove link',
  Url: 'URL',
  'Text to display': 'Text to display',
  Anchors: 'Anchors',
  'Insert link': 'Insert link',
  Link: 'Link',
  'New window': 'New window',
  None: 'None',
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?': 'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?',
  'Paste or type a link': 'Paste or type a link',
  Target: 'Target',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?': 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?',
  'Insert/edit link': 'Insert/edit link',
  'Insert/edit video': 'Insert/edit video',
  Media: 'Media',
  'Alternative source': 'Alternative source',
  'Paste your embed code below:': 'Paste your embed code below:',
  'Insert video': 'Insert video',
  Poster: 'Poster',
  'Insert/edit media': 'Insert/edit media',
  Embed: 'Embed',
  'Nonbreaking space': 'Non-breaking space',
  'Page break': 'Page break',
  'Paste as text': 'Paste as text',
  Preview: 'Preview',
  Print: 'Print',
  Save: 'Save',
  'Could not find the specified string.': 'Could not find the specified string.',
  Replace: 'Replace',
  Next: 'Next',
  'Whole words': 'Whole words',
  'Find and replace': 'Find and replace',
  'Replace with': 'Replace with',
  Find: 'Find',
  'Replace all': 'Replace all',
  'Match case': 'Match case',
  Prev: 'Prev',
  Spellcheck: 'Spell-check',
  Finish: 'Finish',
  'Ignore all': 'Ignore all',
  Ignore: 'Ignore',
  'Add to Dictionary': 'Add to Dictionary',
  'Insert row before': 'Insert row before',
  Rows: 'Rows',
  Height: 'Height',
  'Paste row after': 'Paste row after',
  Alignment: 'Alignment',
  'Border color': 'Border colour',
  'Column group': 'Column group',
  Row: 'Row',
  'Insert column before': 'Insert column before',
  'Split cell': 'Split cell',
  'Cell padding': 'Cell padding',
  'Cell spacing': 'Cell spacing',
  'Row type': 'Row type',
  'Insert table': 'Insert table',
  Body: 'Body',
  Caption: 'Caption',
  Footer: 'Footer',
  'Delete row': 'Delete row',
  'Paste row before': 'Paste row before',
  Scope: 'Scope',
  'Delete table': 'Delete table',
  'H Align': 'H Align',
  Top: 'Top',
  'Header cell': 'Header cell',
  Column: 'Column',
  'Row group': 'Row group',
  Cell: 'Cell',
  Middle: 'Middle',
  'Cell type': 'Cell type',
  'Copy row': 'Copy row',
  'Row properties': 'Row properties',
  'Table properties': 'Table properties',
  Bottom: 'Bottom',
  'V Align': 'V Align',
  Header: 'Header',
  Right: 'Right',
  'Insert column after': 'Insert column after',
  Cols: 'Cols',
  'Insert row after': 'Insert row after',
  Width: 'Width',
  'Cell properties': 'Cell properties',
  Left: 'Left',
  'Cut row': 'Cut row',
  'Delete column': 'Delete column',
  Center: 'Centre',
  'Merge cells': 'Merge cells',
  'Insert template': 'Insert template',
  Templates: 'Templates',
  'Background color': 'Background colour',
  'Custom...': 'Custom...',
  'Custom color': 'Custom colour',
  'No color': 'No colour',
  'Text color': 'Text colour',
  'Table of Contents': 'Table of Contents',
  'Show blocks': 'Show blocks',
  'Show invisible characters': 'Show invisible characters',
  'Words: {0}': 'Words: {0}',
  Insert: 'Insert',
  File: 'File',
  Edit: 'Edit',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help': 'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help',
  Tools: 'Tools',
  View: 'View',
  Table: 'Table',
  Format: 'Format'
});